<template>
  <div>
    <vx-card class="mt-base" :title="activityTitle">
      <p class="mb-5">
        As a vet or a vet nurse, you’ll need to know something about grooming. While your job is not
        that of a professional groomer, there may be times when you’ll need to advise an owner on
        how to keep their dog or cat well-groomed and healthy and hygienic.
      </p>
      <p class="mb-5">
        Watch this short video to hear a vet explain some of the benefits of grooming. This is
        focused on dog grooming, but could be equally applicable to other animals that require
        grooming:
      </p>

      <responsive-youtube-wrapper :video="videos[1]" :image="videoTrigger1" />
      <p class="mb-5">
        Grooming is one of the most basic aspects of animal care. When a dog or cat is properly
        groomed, their coat will be well-ventilated with old and damaged hair removed.
      </p>
      <p class="mb-5">
        Regular grooming is also important to ensure the animal’s skin can breathe. It also reduces
        greasiness and the risk of blocked pores, skin irritations, and lots of other skin-related
        problems.
      </p>
      <p class="mb-5">
        Good brushing also provides the animal with a massage that promotes healthy blood
        circulation and improves muscle tone.
      </p>
      <p class="mb-5">
        Animals can’t tell us when they’re uncomfortable or in pain. Grooming provides us with the
        perfect opportunity to do a basic health check. Some things that can be checked for while
        grooming include:
      </p>
      <ul class="default-list">
        <li>Matting and sores on the skin</li>
        <li>Fleas</li>
        <li>Lumps, bumps, and scratches</li>
        <li>Condition of eyes, ears, and feet.</li>
      </ul>
      <p class="mb-5">Here’s how to do the same for a cat:</p>
      <responsive-youtube-wrapper :video="videos[2]" :image="videoTrigger2" />
      <p class="mb-5">
        Now, try these techniques to check the animal’s skin and to brush their coat for yourself.
      </p>
      <p class="mb-5">
        Did you realise there were so many health reasons for grooming a dog or cat?
      </p>
      <p class="mb-5">
        Part of being a Vet or Vet Nurse is communicating with pet owners regarding their pet’s
        care.
      </p>

      <h4 class="mb-5">Your Task:</h4>
      <p class="mb-5">
        Find someone you know with a dog or cat and talk to them about what you have learned.
      </p>
      <p class="mb-5">Download this form (and save it), fill it out and upload below.</p>
      <p class="mb-5">
        The sheet will assist you in approaching pet owners, delivering information and recording
        your task results.
      </p>

      <label>Download Pet Owner Communication Form</label><br />
      <a
        :href="'content/vet/animal_care_owner_communication.pdf' | blob_url"
        target="_blank"
        class="no-underline btn btn-secondary btn-size-medium includedIcon mt-5"
      >
        <download-icon />Download Pet Owner Communication Form
      </a>
      <vs-divider />

      <p>Upload Completed Form:</p>
      <br />
      <fileupload-button-immediate
        v-model="uploaded_files['uploaded_file_1']"
        :is-editable="isEditable"
        filetype="pdf"
        index="1"
      />

      <save-buttons :is-editable="isEditable" @save="save" />
    </vx-card>
  </div>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
import { DownloadIcon } from 'vue-feather-icons';

export default {
  components: {
    DownloadIcon,
  },
  data() {
    return {
      videoTrigger1: require('@/assets/images/experiences/vet/activity_11.jpg'),
      videoTrigger2: require('@/assets/images/experiences/vet/activity_12.jpg'),
      videos: {
        1: 'https://www.youtube.com/embed/i4PD12vLl2w',
        2: 'https://www.youtube.com/embed/LXJwtuiXm-E',
      },
      login_type: localStorage.getItem('login_type'),
      uploaded_files: {
        uploaded_file_1: '',
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
  mounted() {
    if (typeof this.uploaded_files !== 'undefined') {
      for (let i = 1; i <= Object.keys(this.uploaded_files).length; i++) {
        if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
          this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
        }
      }
    }
  },
};
</script>
